import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function validateMissionToStaffReport(missionToStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.missionToStaffs.validateReport.url, { id: missionToStaffId }))
    .post()
}
